import { useEffect, useState } from 'react';
import '../../assets/css/Announcements.css';
import { getAnnouncements } from '../../utils/AWSAPI';
import LoadingSpinner from '../../utils/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import i18n from "../Translations/i18n/i18n";

function Announcements() {
  // DATA API
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const announcements = await getAnnouncements();
        setData(announcements);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

  const Banner = ({ title, description }) => {
    return (
      <div className="announcement-banner">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    );
  };

  return (
    <div className='App'>
      <LoadingSpinner show={isLoading} />
      <div className="announcement-container">
        {isLoading ? null : data.length > 0 ? (
          data.map((announcement, index) => (
            <Banner key={index} title={announcement.name} description={announcement.title} />
          ))
        ) : (
          <div className="no-announcements-banner">
            <h3>{t('No Active Announcements')}</h3>
            <p>{t('There are currently no important announcements.')}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Announcements;
